/* 
Enum created just as Spartacus ootb enum, but without the const keyword, to avoid the following error when calling this enum:
    Cannot access ambient const enums when 'isolatedModules' is enabled.
Since when we updated Spartacus to 2211.36 version, it enabled the isolatedModules flag in tsconfig.json
*/
export enum ProductScope {
    LIST = 'list',
    DETAILS = 'details',
    ATTRIBUTES = 'attributes',
    VARIANTS = 'variants',
    CODE = 'code',
    PRICE = 'price',
    /** Fetch the default stock information. */
    STOCK = 'stock',
    UNIT = 'unit',
    PROMOTIONS = 'promotions',
    LIST_ITEM = 'list_item',
    MULTI_DIMENSIONAL = 'multi_dimensional',
    MULTI_DIMENSIONAL_AVAILABILITY = 'multi_dimensional_availability',
}